// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"65726a4a","212":"4af02abf","396":"4ab619dd","421":"25b1d5ea","655":"d3e4275c","996":"1965c13b"}[chunkId] + ".chunk.css";
};